<template>
  <promotions-home />
</template>

<script>
import PromotionsHome from "@/components/3pl/CRM/Promotions/Home";
export default {
  components: {
    PromotionsHome,
  },
};
</script>

<style></style>
